(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Fix variant images in collection grid
  (function() {
    function fixItem(item) {
      var variantImg = item.dataset.variantImg;
      var variantId = item.dataset.variantId;
      if (!variantImg) return;
      var variantFilename = variantImg.split('/').pop().split('?')[0];

      // Fix links
      if (variantId) {
        item.querySelectorAll('a[href]').forEach(function(a) {
          var href = a.getAttribute('href');
          if (href && href.indexOf('?variant=') === -1) {
            a.setAttribute('href', href.split('?')[0] + '?variant=' + variantId);
          }
        });
      }

      // Find correct slide
      var slideshow = item.querySelector('slideshow-slides');
      if (!slideshow) return;
      var allSlides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      var targetSlide = null;
      allSlides.forEach(function(slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        var slideFilename = img.src.split('/').pop().split('?')[0];
        if (slideFilename === variantFilename) targetSlide = slide;
      });

      if (!targetSlide) return;

      // Check if already correct
      var firstImg = allSlides[0] && allSlides[0].querySelector('img');
      var firstFilename = firstImg ? firstImg.src.split('/').pop().split('?')[0] : '';
      if (firstFilename === variantFilename) return;

      // Move target to front and show it
      slideshow.insertBefore(targetSlide, allSlides[0]);
      allSlides.forEach(function(slide) {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('hidden', '');
      });
      targetSlide.removeAttribute('hidden');
      targetSlide.setAttribute('aria-hidden', 'false');

      // Reset scroll position to show first slide
      slideshow.scrollLeft = 0;
      slideshow.scrollTop = 0;

      // Also reset the slideshow-component initial-slide attribute
      var slideshowComponent = item.querySelector('slideshow-component');
      if (slideshowComponent) {
        slideshowComponent.setAttribute('initial-slide', '0');
        slideshowComponent.setAttribute('current-slide', '0');
      }
    }

    function fixAll() {
      document.querySelectorAll('.product-grid__item[data-variant-img]').forEach(fixItem);
    }

    function fixAllWithDelay() {
      fixAll();
      setTimeout(fixAll, 50);
      setTimeout(fixAll, 200);
      setTimeout(fixAll, 600);
      setTimeout(fixAll, 1500);
      setTimeout(fixAll, 3000);
    }

    // Watch items that enter viewport (lazy slideshow init)
    function observeItems() {
      if (!window.IntersectionObserver) return;
      var vpObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var item = entry.target;
            fixItem(item);
            setTimeout(function() { fixItem(item); }, 50);
            setTimeout(function() { fixItem(item); }, 200);
            setTimeout(function() { fixItem(item); }, 600);
          }
        });
      }, { rootMargin: '400px' });

      document.querySelectorAll('.product-grid__item[data-variant-img]').forEach(function(item) {
        vpObserver.observe(item);
      });
    }

    // Watch for slideshow-component custom element being defined/upgraded
    if (window.customElements) {
      customElements.whenDefined('slideshow-component').then(function() {
        setTimeout(fixAll, 0);
        setTimeout(fixAll, 100);
        setTimeout(fixAll, 300);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        fixAllWithDelay();
        observeItems();
      });
    } else {
      fixAllWithDelay();
      observeItems();
    }
    document.addEventListener('results-list:updated', function() {
      fixAllWithDelay();
      observeItems();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
